import { render, staticRenderFns } from "./TextFontSizeMobile.vue?vue&type=template&id=c0130618&scoped=true&"
import script from "./TextFontSizeMobile.vue?vue&type=script&lang=ts&"
export * from "./TextFontSizeMobile.vue?vue&type=script&lang=ts&"
import style0 from "./TextFontSizeMobile.vue?vue&type=style&index=0&id=c0130618&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0130618",
  null
  
)

export default component.exports